import React, { useState } from 'react';
import ProfileItemRecommendation from '../ProfileItemRecommendation';
import './styles.css';

const ProfileRecommendations = props => {
  const { list } = props;
  const [showAll, setShowAll] = useState(false);

  const toggleAll = () => {
    setShowAll(!showAll);
  };

  return (
    <div className="profile-recommendations">
      <div className="profile-recommendations__header">
        <span className="profile-recommendations__title">Recommendations:</span>
      </div>

      <ProfileItemRecommendation data={list[0]} />
      {showAll &&
        list.map(
          (item, index) =>
            index > 0 && (
              <ProfileItemRecommendation
                key={item.RecommendationID}
                data={item}
              />
            )
        )}

      {list.length > 1 && (
        <span
          className={
            showAll
              ? 'profile-recommendations__toggle profile-recommendations__toggle--togled '
              : 'profile-recommendations__toggle'
          }
          onClick={toggleAll}
        >
          {showAll ? 'Show Less' : 'Show All'}
        </span>
      )}
    </div>
  );
};

export default ProfileRecommendations;
